<template>
  <div class="vx-col w-full mb-base m-auto">
    <vx-card title="Manage Departments">
      <div class="text-right add-country" v-if="!depAddEdit">
        <vs-button
          class="mt-4 mb-5 m-auto gradient-btn"
          @click.prevent="depAddEdit = true"
        >Add Department</vs-button>
      </div>
      <form class="w-full" v-if="depAddEdit" autocomplete="off">
        <div class="vx-row mb-2">
          <h4 class="ml-5 mb-5">{{ depIndex ? 'Edit' : 'Add' }} Department</h4>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              class="w-full"
              label="Department Name"
              v-validate="'required|max:50'"
              name="department_name"
              v-model="department_name"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('department_name') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-select
              autocomplete
              class="w-full"
              v-validate="'required'"
              label="Office"
              name="office_id"
              v-model="office_id"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.office_name"
                v-for="(item,index) in offices"
              />
            </vs-select>
            <span class="text-danger text-sm">{{ errors.first('office_id') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full" v-show="hr_list.length != 0">
            <vs-select autocomplete class="w-full" label="Manager" name="head_id" v-model="head_id">
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.firstname+' '+item.lastname"
                v-for="(item,index) in hr_list"
              />
            </vs-select>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-button
              class="mt-1 m-auto gradient-btn"
              @click.prevent="addUpdateDepartment()"
              :disabled="button_loading"
              id="dep-addupdate"
            >{{ depIndex ? 'Save' : 'Add' }}</vs-button>
            <vs-button class="mt-1 ml-4 m-auto gradient-btn" @click.prevent="cancelAddEdit()">Cancel</vs-button>
          </div>
        </div>
      </form>
      <div class="mt-5 mb-5">
        <vs-table :data="departments" pagination max-items="15">
          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Office</vs-th>
            <vs-th>Manager</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="dept-name">{{ tr.department_name }}</vs-td>
              <vs-td class="dept-office">{{ tr.office_id.office_name }}</vs-td>
              <vs-td class="dept-head">
                <span
                  v-if="tr.department_head"
                >{{ tr.department_head.firstname | capitalize }} {{ tr.department_head.lastname | capitalize }}</span>
                <span v-else>N/A</span>
              </vs-td>
              <vs-td>
                <vs-button
                  color="#F4B400"
                  type="filled"
                  class="mr-2 mb-2 edit-user float-left"
                  icon-pack="feather"
                  icon="icon-edit-2"
                  size="small"
                  title="Edit Department"
                  @click.stop="editDepartment(data[indextr])"
                ></vs-button>
                <vs-button
                  color="#DB4437"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  size="small"
                  title="Delete Department"
                  @click.stop="confirmDelete(data[indextr].id)"
                ></vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { Validator } from "vee-validate";

Validator.extend("verify_password", {
  //getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)`,
  validate: value => {
    var strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    return strongRegex.test(value);
  }
});

//Validator.updateDictionary(dictionary);

const dict = {
  custom: {
    department_name: {
      required: "Please enter department name",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "Department name should not be greater than 50 characters"
    },
    office_id: {
      required: "Please select office"
    }
  }
};
// register custom messages
Validator.localize("en", dict);

export default {
  data() {
    return {
      departments: [],
      offices: [],
      deleteIndex: 0,
      depAddEdit: false,
      depIndex: null,
      department_name: null,
      office_id: null,
      head_id: null,
      hr_list: []
    };
  },
  created() {
    if (
      this.$store.state.uInfo.role !== "CA" &&
      this.$store.state.uInfo.role !== "HR"
    ) {
      history.back();
    }
    //  VeeValidate.Validator.extend('verify_password', {
    //  //getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)`,
    //  validate: value => {
    //      var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    //      return strongRegex.test(value);
    //  }
    // });
  },
  mounted() {
    this.getHR();
    this.getOffice();
    this.getDepartment();
  },
  computed: {
    email_validate() {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.email);
    }
  },
  methods: {
    getHR() {
      this.$vs.loading({ color: "primary" });

      let url = "user/getUsers?type=HR";
      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          this.hr_list = data;
        })
        .catch(e => {
          this.showError(e);
        });
    },
    getOffice() {
      this.$vs.loading({ color: "primary" });

      let url = "office/getAll";
      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          this.offices = data;
        })
        .catch(e => {
          this.showError(e);
        });
    },
    getDepartment() {
      this.$vs.loading({ color: "primary" });

      let url = "dept/getAll";
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.departments = data;
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    confirmDelete(index) {
      this.deleteIndex = index;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this Department?",
        acceptText: "Delete",
        accept: this.deleteDepartment
      });
    },
    deleteDepartment() {
      let input = {
        data: {
          id: this.deleteIndex
        }
      };
      this.$vs.loading({ color: "primary" });
      this.axios
        .delete("dept/delete", input)
        .then(response => {
          this.$vs.loading.close();
          let text = "Department deleted successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.deleteIndex = 0;
          this.getDepartment();
        })
        .catch(e => {
          this.deleteIndex = 0;
          this.showError(e);
        });
    },
    editDepartment(department) {
      this.depAddEdit = true;
      this.depIndex = department.id;
      this.department_name = department.department_name;
      this.office_id = department.office_id.id;
      if (department.department_head) {
        this.head_id = department.department_head.id;
      }
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    addUpdateDepartment() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.button_loader(true, "#dep-addupdate");

          if (this.depIndex) {
            this.updateDepartment();
          } else {
            this.addDepartment();
          }
        }
      });
    },
    addDepartment() {
      let input = {
        department_name: this.department_name,
        office_id: this.office_id,
        department_head: this.head_id
      };
      this.axios
        .post("dept/create", input)
        .then(response => {
          this.button_loader(false, "#dep-addupdate");
          let text = "Department created successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.depAddEdit = false;
          this.department_name = null;
          this.office_id = null;
          this.head_id = null;
          this.depIndex = null;
          this.getDepartment();
        })
        .catch(e => {
          this.showError(e, "#dep-addupdate");
        });
    },
    updateDepartment() {
      let input = {
        id: this.depIndex,
        department_name: this.department_name,
        office_id: this.office_id,
        department_head: this.head_id
      };
      this.axios
        .put("dept/edit", input)
        .then(response => {
          this.button_loader(false, "#country-addupdate");
          let text = "Department updated successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.depAddEdit = false;
          this.department_name = null;
          this.office_id = null;
          this.head_id = null;
          this.depIndex = null;
          this.getDepartment();
        })
        .catch(e => {
          this.showError(e, "#dep-addupdate");
        });
    },
    cancelAddEdit() {
      this.depAddEdit = false;
      this.department_name = null;
      this.office_id = null;
      this.head_id = null;
      this.depIndex = null;
    }
  }
};
</script>
<style>
.dept-name {
  max-width: 130px !important;
  word-break: break-all;
}
</style>

		